import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimaryFive = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimaryFive.palette['--sui-palette-background-primary'] = '238 226 215';

export { WinterHoliday2026PrimaryFive };